import moment from 'moment'
export const isCitasProximas = (fecha) =>{
    let f = moment(fecha, "YYYY-MM-DDTHH:mm:ss")
    return moment().isSameOrBefore(f);
}